export enum Variables {
  APP_API,
  CHAT_API,
}

export function getVariable(variable: Variables) {
  switch (variable) {
    case Variables.APP_API:
      if (__APP_API__ && __APP_API__.indexOf("<APP_API>") === -1) {
        return __APP_API__;
      }
      return undefined;
    case Variables.CHAT_API:
      if (__CHAT_API__ && __CHAT_API__.indexOf("<CHAT_API>") === -1) {
        return __CHAT_API__;
      }
      return undefined;
  }
}
